export default function Tos() {
  return (
    <div>
      <h1>TERMS & CONDITIONS</h1>
      Lisa Mona is a collection of NFTs running on the Ethereum network. This website is only an
      interface allowing participants to exchange digital collectibles. Users are entirely
      responsible for the safety and management of their own private Ethereum wallets and validating
      all transactions and contracts generated by this website before approval. Furthermore, as the
      Lisa Mona smart contract runs on the Ethereum network, there is no ability to undo, reverse,
      or restore any transactions. This website and its connected services are provided “as is” and
      “as available” without warranty of any kind. By using this website you are accepting sole
      responsibility for any and all transactions involving Lisa Mona digital collectibles.
      <br />
      <br />
      <h2>OWNERSHIP</h2>
      <h3>LISA MONA ARTISTS</h3>
      i. Each Lisa Mona artist is an NFT on the Ethereum blockchain. When you purchase an NFT, you
      own the underlying Art completely. Ownership of the NFT is mediated entirely by the Smart
      Contract and the Ethereum Network: at no point may we seize, freeze, or otherwise modify the
      ownership of any Lisa Mona NFT.
      <br />
      <br />
      ii. Personal Use. Subject to your continued compliance with these Terms, Lisa Mona LLC grants
      you a worldwide, royalty-free license to use, copy, and display the purchased Art, along with
      any extensions that you choose to create or use, solely for the following purposes: (i) for
      your own personal, non-commercial use; (ii) as part of a marketplace that permits the purchase
      and sale of your Lisa Mona NFT, provided that the marketplace cryptographically verifies each
      Lisa Mona owner's rights to display the Art for their Lisa Mona artist to ensure that only the
      actual owner can display the Art; or (iii) as part of a third party website or application
      that permits the inclusion, involvement, or participation of your Lisa Mona artist, provided
      that the website/application cryptographically verifies each Lisa Mona artist owner's rights
      to display the Art for their Lisa Mona artist to ensure that only the actual owner can display
      the Art, and provided that the Art is no longer visible once the owner of the Lisa Mona artist
      leaves the website/application.
      <br />
      <br />
      iii. Commercial Use. Subject to your continued compliance with these Terms, Lisa Mona LLC
      grants you an unlimited, worldwide license to use, copy, and display the purchased Art for the
      purpose of creating derivative works based upon the Art (“Commercial Use”). Examples of such
      Commercial Use would e.g. be the use of the Art to produce and sell merchandise products
      (T-Shirts etc.) displaying copies of the Art. For the sake of clarity, nothing in this Section
      will be deemed to restrict you from (i) owning or operating a marketplace that permits the use
      and sale of the art generally, provided that the marketplace cryptographically verifies each
      owner's rights to display the Art for their Art to ensure that only the actual owner can
      display the Art; (ii) owning or operating a third party website or application that permits
      the inclusion, involvement, or participation of Lisa Mona artists generally, provided that the
      third party website or application cryptographically verifies each owner's rights to display
      the Art for their Lisa Mona artist to ensure that only the actual owner can display the Art,
      and provided that the Art is no longer visible once the owner of the Purchased Lisa Mona
      artist leaves the website/application; or (iii) earning revenue from any of the foregoing.
      <br />
      <br />
      <h3>LISA MONA HYBRIDS</h3>
      i. Each Lisa Mona hybrid is an NFT on the Ethereum blockchain. When you purchase an NFT, you
      own the underlying Art completely. Ownership of the NFT is mediated entirely by the Smart
      Contract and the Ethereum Network: at no point may we seize, freeze, or otherwise modify the
      ownership of any Lisa Mona NFT.
      <br />
      <br />
      ii. Personal Use. Subject to your continued compliance with these Terms, Lisa Mona LLC grants
      you a worldwide, royalty-free license to use, copy, and display the purchased Art, along with
      any extensions that you choose to create or use, solely for the following purposes: (i) for
      your own personal, non-commercial use; (ii) as part of a marketplace that permits the purchase
      and sale of your Lisa Mona NFT, provided that the marketplace cryptographically verifies each
      Lisa Mona owner's rights to display the Art for their Lisa Mona hybrid to ensure that only the
      actual owner can display the Art; or (iii) as part of a third party website or application
      that permits the inclusion, involvement, or participation of your Lisa Mona hybrid, provided
      that the website/application cryptographically verifies each Lisa Mona hybrid owner's rights
      to display the Art for their Lisa Mona hybrid to ensure that only the actual owner can display
      the Art, and provided that the Art is no longer visible once the owner of the Lisa Mona hybrid
      leaves the website/application.
      <br />
      <br />
      iii. Commercial Use. Subject to your continued compliance with these Terms, Lisa Mona LLC
      grants you an unlimited, worldwide license to use, copy, and display the purchased Art for the
      purpose of creating derivative works based upon the Art (“Commercial Use”). Examples of such
      Commercial Use would e.g. be the use of the Art to produce and sell merchandise products
      (T-Shirts etc.) displaying copies of the Art. For the sake of clarity, nothing in this Section
      will be deemed to restrict you from (i) owning or operating a marketplace that permits the use
      and sale of the art generally, provided that the marketplace cryptographically verifies each
      owner's rights to display the Art for their Art to ensure that only the actual owner can
      display the Art; (ii) owning or operating a third party website or application that permits
      the inclusion, involvement, or participation of Lisa Mona hybrids generally, provided that the
      third party website or application cryptographically verifies each owner's rights to display
      the Art for their Lisa Mona hybrid to ensure that only the actual owner can display the Art,
      and provided that the Art is no longer visible once the owner of the Purchased Lisa Mona
      hybrid leaves the website/application; or (iii) earning revenue from any of the foregoing.
      <br />
      <br />
      <h3>LISA MONA ARTWORKS</h3>
      i. Each Lisa Mona artwork is an NFT on the Ethereum blockchain. When you purchase an NFT, you
      own a representation of the original artwork. Ownership of the NFT is mediated entirely by the
      Smart Contract and the Ethereum Network: at no point may we seize, freeze, or otherwise modify
      the ownership of any Lisa Mona NFT.
      <br />
      <br />
      ii. Fair Use. All non-hybrid, non-artist artworks in the Lisa Mona collection are part of the
      public domain and are subject to all Fair Use rules for any public domain artworks.
    </div>
  );
}
